import React from 'react'

import { Button, Color, withCitrusTheme } from '@gousto-internal/citrus-react'

import { useIsRecipeInStock } from 'hooks/menu-recipes/useIsRecipeInStock'
import { RecipeCoreId, RecipeUUID } from 'reducers/menu-recipes/recipes'

import { RecipeDetailsButtons } from '../Buttons'

import css from './AddRecipeButton.css'

type AddRecipeButtonProps = {
  id: RecipeUUID
  coreId: RecipeCoreId
  isChefPrepared?: boolean
  position?: string
  surcharge?: number
}

const DisabledButton = withCitrusTheme(Button, (theme) => ({
  '&:disabled, &:disabled:hover, &:disabled:focus': {
    color: theme.color(Color.White),
  },
}))

export const AddRecipeButton = ({
  id,
  coreId,
  isChefPrepared,
  position,
  surcharge,
}: AddRecipeButtonProps) => {
  const isOutOfStock = !useIsRecipeInStock(id)
  const buttonText = isChefPrepared ? 'Add meal' : 'Add recipe'

  return (
    <div className={css.addRecipeWrapper}>
      {isOutOfStock ? (
        <DisabledButton aria-label="Sold out recipe" disabled width="100%">
          Sold out
        </DisabledButton>
      ) : (
        <RecipeDetailsButtons
          position={position}
          recipeId={coreId}
          isOutOfStock={isOutOfStock}
          buttonText={buttonText}
          surcharge={surcharge}
        />
      )}
    </div>
  )
}
